const currency_formatters = {
  usd: new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }),
  eur: new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
  }),
};
export const format_currency = (amount, currency) => {
  if (currency_formatters[currency]) {
    return currency_formatters[currency].format(amount);
  }
  return `${amount} ${currency}`;
};
const getSubscriptionCardHeader = (subscription_plan) => {
  let main_price =
    subscription_plan.stripe_plan.unit_amount === 0
      ? `<span class="subscription_plan-price_amount">Gratuit</span>`
      : `
      <span class="subscription_plan-price_amount">${format_currency(subscription_plan.stripe_plan.unit_amount / 100, subscription_plan.stripe_plan.currency)}</span>
      <span class="subscription_plan-price_period"> / mois</span> `;
  main_price = `
  <div class="subscription_plan-price slds-m-bottom_small">
  ${main_price}
  </div>`;
  let promo_ribbon = '';
  let promo_price = '';
  if (subscription_plan.stripe_plan.coupon) {
    const coupon = subscription_plan.stripe_plan.coupon;
    promo_ribbon = '<div class="premium-ribbon"><span>PROMOTION</span></div>';
    promo_price = `
    <div class="subscription_plan-price slds-m-bottom_small">
      <span style="text-decoration: line-through;">${format_currency(subscription_plan.stripe_plan.unit_amount / 100, subscription_plan.stripe_plan.currency)}</span>
      <span class="subscription_plan-price_amount" style="font-weight:400;">
        ${format_currency(subscription_plan.stripe_plan.unit_amount / 100 - coupon.amount_off / 100, subscription_plan.stripe_plan.currency)}</span>
      <span class="subscription_plan-price_period"> / mois</span>
    </div>`;
    main_price = '';
  }
  return `
  ${promo_ribbon}
  <div class="subscription_plan-header">
    <div>
      ${promo_price}
      ${main_price}      
      <div class="slds-text-heading_small subscription_plan-name slds-m-bottom_small">${subscription_plan.label}</div>
    </div>
  </div>`;
};

const getSubscriptionCardBody = (subscription_plan, options = {}) => {
  const show_footer = options?.show_footer ?? false;
  const card_footer = show_footer
    ? `<div class="subscription_plan-footer">
    ${getSubscriptionCardFooter(subscription_plan, options)}
    </div>`
    : '';
  return `
  <div class="subscription_plan-body">
    <div class="green-top-ellipse"></div>
    ${getSubscriptionIcon(subscription_plan)}
    <div class="subscription_plan-features">
    ${getSubscrptionFeatureList(subscription_plan)}
    </div>
    ${card_footer}
  </div>`;
};

const getSubscriptionCardFooter = (subscription_plan, options = {}) => {
  let btn_label = `Devenir ${subscription_plan.label}`;
  let btn_class = 'ggo-cta';
  if (subscription_plan.stripe_plan.id !== options.starter_plan.plan_id) {
    if (subscription_plan.stripe_plan.coupon) {
      const new_price = subscription_plan.stripe_plan.unit_amount - subscription_plan.stripe_plan.coupon.amount_off;
      btn_label = `Devenir ${subscription_plan.label} pour ${format_currency(new_price / 100, subscription_plan.stripe_plan.currency)}/mois`;
      btn_class = 'ggo-promo';
    }
    return `
    <button class="slds-button slds-button_brand ${btn_class} slds-hide" data-planid="${subscription_plan.stripe_plan.id}" data-action="subscribe">${btn_label}</button>
    <button class="slds-button slds-button_destructive ggo-cta slds-hide" data-planid="${subscription_plan.stripe_plan.id}" data-action="cancel-subscription">Annuler l'abonnement</button>`;
  }
  return `<button class="slds-button slds-button_brand ${btn_class} slds-hide" data-planid="${subscription_plan.stripe_plan.id}" data-action="subscribe">S'inscrire gratuitement</button>`;
};

const getSubscrptionFeatureList = (subscription_plan) => {
  const subscription_features_list = subscription_plan.feature_list;
  let features = subscription_features_list.features;
  let previou_plan = subscription_features_list?.previous ?? '';
  let sub_features = '';
  if (subscription_features_list.sub_features) {
    sub_features = `
    <div style="margin-left: 30px;">
      <div style="font-size:10px;font-weight:bold;">Comprenant :</div>
      <div>
        <ul class="slds-list_dotted">
          ${subscription_features_list.sub_features
            .map((sf) => {
              return `<li>${sf}</li>`;
            })
            .join('')}
        </ul>
      </div>
    </div>`;
  }
  let more_info = '';
  if (subscription_features_list.more) {
    more_info = `<div class="slds-m-top_x-small" style="font-size: 10px;">${subscription_features_list.more}</div>`;
  }
  return `
  <div class="subcription-feature-previous-plan">${previou_plan}</div>
  <div class="slds-p-horizontal_small">
    <ul>
    ${features
      .map((f) => {
        return `
        <li class="slds-item subcription-feature slds-m-top_x-small">
          <div style="display:flex;">
            <span class="slds-icon_container slds-icon-utility-check slds-current-color slds-m-right_small" title="True">
              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/styles/slds/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
              </svg>
              <span class="slds-assistive-text">True</span>
            </span>
            <div style="vertical-align: top;">${f}</div>
          </div>
        </li>
      `;
      })
      .join('')}    
    </ul>
    ${sub_features}
    ${more_info}
  </div>`;
};

const getSubscriptionIcon = (subscription_plan) => {
  let img_src = null;
  switch (subscription_plan.label.toLowerCase()) {
    case 'basique':
      img_src = '/images/subscription/basique.png';
      break;
    case 'pro':
      img_src = '/images/subscription/pro.png';
      break;
    case 'expert':
      img_src = '/images/subscription/expert.png';
      break;
  }

  let sub_img = '';
  if (img_src) {
    sub_img = `<img src="${img_src}" />`;
  }

  return `<div class="subscription_plan_image slds-m-bottom_x-large slds-align_absolute-center">${sub_img}</div>`;
};
export const get_subscriptionplan_card = (subscription_plan, options = {}) => {
  let content = `
    <div class="slds-box subscription_plan-card subscription_plan-card_${subscription_plan.label.toLowerCase()}" data-planid="${
    subscription_plan?.stripe_plan?.id ?? subscription_plan.stripe_plan_id
  }">
      ${getSubscriptionCardHeader(subscription_plan)}
      ${getSubscriptionCardBody(subscription_plan, options)}
    </div>
    `;

  return content;
};

export const get_subscriptionplan_globalheader = (subscription_plans = []) => {
  const coupons = subscription_plans
    .filter((s) => typeof s.stripe_plan.coupon !== 'undefined')
    .map((s) => s.stripe_plan.coupon)
    .sort((c1, c2) => c1.redeem_by - c2.redeem_by);
  if (coupons.length === 0) {
    return '';
  }
  const coupon = coupons[0];
  const label = coupon.metadata?.label ?? 'Promotion en cours';
  const message = coupon.metadata?.message ?? 'Profitez de nos prix promotionnels.';
  const g_header = `
  <div style="text-align:center;">
    <div class="slds-text-heading_large" style="font-weight: 700;">${label}</div>
    <div class="slds-text-heading_small" style="font-weight: 400; color: #FF0000;">${message}</div>
  </div>
  `;
  return g_header;
};
